import { useFormikContext } from "formik";
import { FC, useState } from 'react';
import { DEF_PG_SIZE_SUB } from '../../../../constants/maximum-page-size';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import { useLocale } from '../../../../contexts/localeContext';
import { TableContextProvider } from '../../../../contexts/table/TableContextProvider';
import { getAllAccessGroups } from "../../../../services/accessGroupService";
import AccessGroupColumns from "../../../../models/ColumnDefinitions/AccessGroupColumns";
import { ListQuery } from "../../../../models/ListQuery";
import { Lookup } from "../../../../models/Lookup";
import LookupTypes from "../../../../models/LookupTypes";
import AccessGroupSearch from "../../../../models/search/AccessGroupSearch";
import SiteSearch from "../../../../models/search/SiteSearch";
import { removeColumns } from "../../../../models/utilities/columnHelper";
import { getSiteNamesWithPagination } from "../../../../services/siteService";
import TableTab from "../../../tabs/table-tab";
import { WizardStepLayout } from '../../../wizard/wizard-summary-layout';
import { GROUP_TYPE } from "@/constants/area-constants";
import { ACCESS_TYPES } from "@/constants/access-constants";

interface GroupStepProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    setSideBarStepDescription: (discription: string) => void;
    groupType: GROUP_TYPE // 1 = Access Groups, 2 = Floor Groups
}

const GroupStep: FC<GroupStepProps> = ({ onBack, onNext, setSideBarStepDescription, groupType }) => {
    const { translate } = useLocale();
    const { setFieldValue } = useFormikContext<any>();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    const isAccessGroup = groupType == ACCESS_TYPES.ACCESS_GROUP;
    const isFloorGroup = groupType == ACCESS_TYPES.FLOOR_GROUP;
    const isOssGroup = groupType == ACCESS_TYPES.OSS_GROUP;

    const onLocalNext = (event: any) => {
        setFieldValue(isAccessGroup ? 'accessGroupsIds' : isFloorGroup ? 'floorGroupsIds' : 'ossGroupsIds', selectedIds);
        setFieldValue(isAccessGroup ? 'accessGroups' : isFloorGroup ? 'floorGroups' : 'ossGroups', selectedRows);
        setSideBarStepDescription(`${selectedIds.length} ${translate.byKey(TranslationKeys.selected)}`);
        onNext({ ...event });
    };

    const filterToNameAndSiteOnly = searchDescriptor => {
        return searchDescriptor.filter(item => item.accessor === 'name' || item.accessor === 'site');
    };

    const lookup: Lookup[] = [{
        name: LookupTypes.site,
        values: [],
        dataMethod: getSiteNamesWithPagination,
        searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
    }]
    
    return <WizardStepLayout onBack={onBack} onNext={onLocalNext}>
            <TableContextProvider
                dataMethod={(listParameters?: ListQuery) => getAllAccessGroups(groupType, translate, listParameters)}
                tableDescriptor={isOssGroup ? removeColumns(AccessGroupColumns, ['area', 'days', 'startTime', 'duration', 'enrolments', 'accessProfile']) : removeColumns(AccessGroupColumns, ['days', 'startTime', 'duration', 'enrolments', 'accessProfile'])}
                searchDescriptor={filterToNameAndSiteOnly(AccessGroupSearch)}
                useTable
                usePagination
                useSearch
                useSort
                useFilter
                maxPageSize={DEF_PG_SIZE_SUB}
                lookup={lookup}
                canExportReport={false}>
                <TableTab
                    title={translate.byKey(isAccessGroup ? TranslationKeys.accessGroups : isFloorGroup ? TranslationKeys.floorGroups : TranslationKeys.ossGroups)}
                    selectRows={true}
                    selectedIds={selectedIds}
                    selectedRows={selectedRows}
                    setSelectedIds={setSelectedIds}
                    setSelectedRows={setSelectedRows}
                    cyName={isAccessGroup ? "accessGroupStep" : isFloorGroup ? "floorGroupStep" : "ossGroupStep"}/>
            </TableContextProvider>
    </WizardStepLayout>
};

export default GroupStep;
